import React from "react";
import { useNavigate } from "react-router-dom";
import { FauxWindow } from "../ui/FauxWindow";

export default function Hero() {
    const navigate = useNavigate();

    return (
        <section className="vy-section" id="top" data-testid="landing-hero">
            <div className="vy-container">
                <div style={{ display: "grid", gridTemplateColumns: "1.05fr 1fr", gap: 56, alignItems: "center" }} className="vy-grid-2">
                    {/* Left column */}
                    <div>
                        <div className="vy-kicker vy-reveal" data-vy-delay="1" data-testid="hero-kicker">
                            &gt; vyaahar.init
                        </div>
                        <h1
                            className="vy-serif-i vy-reveal vy-hero-title"
                            data-vy-delay="2"
                            style={{ fontSize: "4rem", lineHeight: 1.02, marginTop: 12, color: "var(--vy-navy)", letterSpacing: -0.02 }}
                            data-testid="hero-headline"
                        >
                            Your books,{" "}
                            <span className="vy-serif" style={{ color: "var(--vy-gold)", fontStyle: "normal" }}>finally</span>
                            {" "}in one system.
                        </h1>
                        <p
                            className="vy-reveal vy-hero-sub"
                            data-vy-delay="3"
                            style={{ marginTop: 20, fontSize: 17, color: "var(--vy-muted)", lineHeight: 1.55, maxWidth: 540 }}
                        >
                            Cloud accounting built for how Indian businesses actually run. Double-entry, GST,
                            e-invoicing, TDS, multi-currency, AI copilot. One workspace. One source of truth.
                        </p>

                        <div className="vy-reveal" data-vy-delay="4" style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 28 }}>
                            <button
                                type="button"
                                className="vy-btn vy-btn-primary"
                                onClick={() => navigate("/signup")}
                                data-testid="hero-start-free"
                            >
                                Start free · no card
                                <span aria-hidden style={{ marginLeft: 4 }}>→</span>
                            </button>
                            <a href="#product" className="vy-btn vy-btn-ghost" data-testid="hero-see-tour">
                                See it in 90s
                            </a>
                        </div>
                    </div>

                    {/* Right column — real dashboard screenshot */}
                    <div className="vy-reveal" data-vy-delay="3" data-testid="hero-mockup">
                        <FauxWindow title="VYAAHAR.APP  ·  /DASHBOARD" bodyStyle={{ padding: 0 }}>
                            <img
                                src="/landing-shots/dashboard.png"
                                alt="Vyaahar dashboard — command center with Activity Tape, Net Profit hero, and AI Copilot panel"
                                style={{ display: "block", width: "100%", height: "auto" }}
                                loading="eager"
                                data-testid="hero-dashboard-image"
                            />
                        </FauxWindow>
                    </div>
                </div>
            </div>
        </section>
    );
}
